// src/hooks/useSavedRecipes.js  —  ohapotato v2026.10.36
// Persists saved recipes per user in localStorage.
// Key: `ohp-saved-${userId}`
import { useState, useEffect, useCallback } from 'react';

export function useSavedRecipes(userId) {
  const storageKey = userId ? `ohp-saved-${userId}` : null;

  const [saved, setSaved] = useState(() => {
    if (!storageKey) return [];
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch { return []; }
  });

  // Reload when user changes (login / logout)
  useEffect(() => {
    if (!storageKey) { setSaved([]); return; }
    try {
      setSaved(JSON.parse(localStorage.getItem(storageKey) || '[]'));
    } catch { setSaved([]); }
  }, [storageKey]);

  // Persist on change
  useEffect(() => {
    if (!storageKey) return;
    localStorage.setItem(storageKey, JSON.stringify(saved));
  }, [saved, storageKey]);

  const saveRecipe = useCallback((recipe) => {
    setSaved(prev => {
      if (prev.find(r => r.id === recipe.id)) return prev;
      return [recipe, ...prev];
    });
  }, []);

  const removeRecipe = useCallback((recipeId) => {
    setSaved(prev => prev.filter(r => r.id !== recipeId));
  }, []);

  const savedIds = saved.map(r => r.id);

  return { saved, savedIds, saveRecipe, removeRecipe };
}
